import React from 'react';
import PropTypes, { any } from 'prop-types';

import { ToggleSwitch } from '../../../Form';

const DivisionDrawAssociationToggle = (props) => {
    const {
        field,
        formApi,
        disabled,
    } = props;

    return (
        <div className={`col-12`}>
            <ToggleSwitch
                id={'divisionDrawAssociation'}
                field={field}
                formGroupCssClass={`mb16`}
                label="Require divisions be associated with draws"
                description="If enabled, draws may only include players registered in divisions with the same gender and game type."
                isEventEditForm
                disabled={disabled}
                onChange={(val) => {
                    if (!val) {
                        formApi.setValue('divisionDrawAssociation', false);
                        formApi.setValue('awardCombinedDivisionDrawMedal', false);
                        formApi.setError(false);
                    }
                    if (val) {
                        formApi.setValue('divisionDrawAssociation', true);
                        formApi.setError(false);
                    }
                }}
                reverse={false}
            />
            <div className="div div16" />

        </div>
    );
};
DivisionDrawAssociationToggle.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
    disabled: PropTypes.bool,
};
DivisionDrawAssociationToggle.defaultProps = {
    disabled: false,
};
export default DivisionDrawAssociationToggle;
